import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class BackgroundLoadingService {
  private loadingSubject = new BehaviorSubject<boolean>(false)
  public loading$ = this.loadingSubject.asObservable()

  constructor() {}

  setLoadingState(isLoading: boolean): void {
    this.loadingSubject.next(isLoading)
  }
}
